import _ from 'lodash'
import type { ValidationErrorsMap } from './validator'

export function buildErrorTree(errors: ValidationErrorsMap) {
  const results = {}
  _.forEach(errors, (error, key) => {
    const keyArray = key.split('.')
    const errorsKey = keyArray.concat(['_errors'])
    const errorsArray = _.get(results, errorsKey, [])
    errorsArray.push(error)
    _.set(results, errorsKey, errorsArray)
  })
  return results
}
